import { ActivityType, CreateActivityType, UpdateActivityType } from '@/entities/activityType';
import { Api } from './api/axios-config';

export class ActivityTypeService{
  private static api = Api();

  public static async getActivityTypes(): Promise<ActivityType[] | null>{
    const response = await this.api.get<any>('/activity-type');

    if(response.status === 200){
      return response.data.map((data:any)=>({
        id:data.id,
        name:data.name,
      }));
    }
    return null;
  }

  public static async createActivityTypes(activityType: CreateActivityType){
    const response = await this.api.post<any>('/activity-type/create', activityType);

    if(response.status === 201){
      return {
        id: response.data.id,
        name: response.data.name 
      };
    }
    return null;
  }

  public static async updateOrCreateActivityTypes(activityTypes: UpdateActivityType[]){
    const response =  await this.api.post<any>('/activity-type/update-create',{
      activityTypes:activityTypes.map((activityType) =>({
        id:activityType.id,
        name:activityType.name
      }))}
    );
    if(response.status === 201){
      return response.data.map((data: any) => ({
        id: data.id,
        name: data.name,
      }));
    }
    return null;
  }

  public static async searchActivityTypes(contains: string){
    const response = await this.api.post<any>('/activity-type/search', { contains });
    if(response.status === 201){
      return response.data.map((data: any) => ({
        id: data.id,
        name: data.name,
      }));
    }
    return null;
  }

  public static async deleteActivityTypes(id: number){
    const response = await this.api.delete<any>(`/activity-type/${id}`);
    if(response.status === 200){
      return {
        id: response.data.id,
        name: response.data.name
      };
    }
    return null;
  }
}

